import { Team } from "common";
import { useCallback, useEffect } from "react";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { isParamNumeric } from "../utils/utils";

export const useGetTeamById = (
  id: number | string | undefined
): [Team | null, () => void] => {
  const api = useAPI();
  const { data, query } = useAPIQuery({ apiCall: api.teamGet });

  const fetchTeam = useCallback(() => {
    if (typeof id === "number") {
      query({ id });
    } else if (typeof id === "string" && isParamNumeric(id)) {
      query({ id: Number(id) });
    }
  }, [id, query]);

  useEffect(() => {
    fetchTeam();
  }, [fetchTeam]);
  if (!id) {
    return [null, fetchTeam];
  }
  return [data?.teams[0] ?? null, fetchTeam];
};
